module.exports = __webpack_public_path__ + "static/media/attachment.63791d2e.png";